var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Multiply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14.001,
    viewBox: "0 0 14 14.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-multiply",
    d: "M5.988,4.99a1,1,0,0,0-.7,1.714l5.283,5.283L5.292,17.271A1,1,0,1,0,6.7,18.682L11.987,13.4l5.283,5.283a1,1,0,1,0,1.411-1.411L13.4,11.987,18.682,6.7a1,1,0,1,0-1.411-1.411l-5.283,5.283L6.7,5.292a1,1,0,0,0-.715-.3Z",
    transform: "translate(-4.99 -4.99)",
    fill: "#ff4d4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Multiply);
export default __webpack_public_path__ + "static/media/icons8-multiply.402ca8a91bb5adfa03d64aada4fae8eb.svg";
export { ForwardRef as ReactComponent };